/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { darken } from 'polished';

export const Container = styled.div`
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: -30px;
  background: #090f35;

  h1,
  h2,
  h3,
  h4,
  p {
    color: #fff;
    text-align: center;
    margin: 5px;
  }

  button {
    height: 50px;
    width: 360px;
    background: #36ded6;
    font-weight: bold;
    color: #090f35;
    border: 0;
    border-radius: 5px;
    font-size: 14px;
    transition: background 0.2s;
    margin-left: 38%;

    &:hover {
      background: ${darken(0.08, '#36ded6')};
    }
  }
`;

export const Card = styled.div`
  align-self: center;
  justify-content: center;

  background: rgba(138, 255, 248, 0.1);

  border-radius: 10px;
  padding: 10px;

  width: 850px;
  max-width: 850px;

  margin: 50px auto;

  div.tag {
    width: 60px;
    height: 60px;
    border-radius: 30px;
    background: #fff;

    position: relative;
    top: -30px;
    left: 750px;

    border: 7px solid #ffd700;
    background: #090f35;

    div {
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      color: #fff;
    }
  }

  div.link {
    margin: 20px auto;
    width: 500px;
  }

  div.slider {
    width: 300px;
    margin: 0 auto;
    margin-top: 40px;
    margin-bottom: 20px;
    color: #fff;
    border-top-width: 1px;
    border-top-style: dashed;
    border-top-color: #fff;

    p {
      font-size: 16px;
      margin-top: 20px;
    }

    div.support {
      margin-left: -50px;

      button {
        /* margin: 60px 35% 0 */
        margin-left: 10px;
        height: 40px;
        width: 100px;
        background: #36ded6;
        font-weight: bold;
        color: #090f35;
        border: 0;
        border-radius: 5px;
        font-size: 14px;
        transition: background 0.2s;

        position: relative;
        left: 360px;
        top: -45px;

        &:hover {
          background: ${darken(0.08, '#36ded6')};
        }
      }
    }
  }
`;

export const Challenge = styled.div`
  align-self: center;
  justify-content: center;

  background: rgba(34, 167, 240, 0.3);

  border-radius: 10px;
  padding: 10px;

  width: 850px;
  max-width: 850px;

  margin: 50px auto;

  div.tag {
    width: 60px;
    height: 60px;
    border-radius: 30px;
    background: #fff;

    position: relative;
    top: -30px;
    left: 750px;

    border: 7px solid #ffd700;
    background: #090f35;

    div {
      margin-top: 7px;
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      color: #090f35;
    }
  }

  input {
    background: rgba(0, 0, 0, 0);
    border: 1px solid #36ded6;
    border-radius: 5px;
    box-sizing: border-box;
    width: 650px;
    height: 50px;
    padding: 0 15px;
    color: #fff;
    margin: 0 7px 14px;

    &::placeholder {
      color: #fff;
    }
  }

  button {
    /* margin: 60px 35% 0 */
    margin-left: 10px;
    height: 50px;
    width: 100px;
    background: #36ded6;
    font-weight: bold;
    color: #090f35;
    border: 0;
    border-radius: 5px;
    font-size: 14px;
    transition: background 0.2s;

    &:hover {
      background: ${darken(0.08, '#36ded6')};
    }
  }

  a {
    color: #fff;
    text-decoration: underline;
  }

  a:hover {
    color: #36ded6;
    text-decoration: underline;
  }
`;

export const ChallengeCode = styled.div`
  align-self: center;
  justify-content: center;

  background: rgba(34, 167, 240, 0.2);

  border-radius: 10px;
  padding: 10px;

  width: 850px;
  max-width: 850px;

  margin: 50px auto;

  div.tag {
    width: 60px;
    height: 60px;
    border-radius: 30px;
    background: #fff;

    position: relative;
    top: -30px;
    left: 750px;

    border: 7px solid #ffd700;
    background: #090f35;

    div {
      margin-top: 7px;
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      color: #090f35;
    }
  }

  div.ace {
    margin-left: 40px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  button {
    margin-left: 40px;
    margin-bottom: 20px;
    height: 50px;
    width: 700px;
    background: #36ded6;
    font-weight: bold;
    color: #090f35;
    border: 0;
    border-radius: 5px;
    font-size: 14px;
    transition: background 0.2s;

    &:hover {
      background: ${darken(0.08, '#36ded6')};
    }
  }

  a {
    color: #fff;
    text-decoration: underline;
  }

  a:hover {
    color: #36ded6;
    text-decoration: underline;
  }
`;
